import React from 'react';
import { Layers } from 'lucide-react';
import { initials } from '../../utils/format';

/**
 * Ảnh đại diện của ứng dụng, có sẵn placeholder cho những ứng dụng chưa có ảnh
 * (chữ cái đầu trên nền gradient nhẹ) nên lưới card không bị "thủng lỗ".
 */
const AppThumbnail = ({ app, className = '', imageClassName = '' }) => {
    if (app.thumbnail) {
        return (
            <img
                src={app.thumbnail}
                alt={app.title}
                loading="lazy"
                className={`w-full h-full object-cover ${imageClassName} ${className}`}
            />
        );
    }

    return (
        <div
            className={`w-full h-full flex flex-col items-center justify-center gap-2 bg-gradient-to-br from-slate-100 to-slate-200 dark:from-slate-800 dark:to-slate-900 ${className}`}
        >
            <span className="text-3xl font-bold text-slate-400 dark:text-slate-600 tracking-tight">
                {initials(app.title) || <Layers className="w-8 h-8" />}
            </span>
        </div>
    );
};

export default AppThumbnail;
